import axios from 'axios';

const updateSettings = followUpEnabled => {
  return axios.put('faqs/settings', {
    has_follow_ups_enabled: followUpEnabled
  });
};

export { updateSettings };
